export const AWS_ACTION_TYPES = {
  SET_AWS_KEYS: "SET_AWS_KEYS",
};
